import { render, staticRenderFns } from "./SaTabs.vue?vue&type=template&id=2b0a96ac&scoped=true&"
import script from "./SaTabs.vue?vue&type=script&lang=js&"
export * from "./SaTabs.vue?vue&type=script&lang=js&"
import style0 from "./SaTabs.vue?vue&type=style&index=0&id=2b0a96ac&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a96ac",
  null
  
)

export default component.exports